import { ReactNode, useEffect } from 'react';
import {
    ContentfulProvider as ContentfulProviderFoundations,
    useConfigurationData,
    useContentfulConfigs
} from '@vfmfe/foundations';
import { useSelector } from '../../modules/store';
import { RootState } from '../../redux/store';
import { getContentfulConfiguration } from '../../modules/contentful';

interface ContentfulProviderProps {
    children: ReactNode;
}

const ShellAdapterInjector = () => {
    const configurationData = useConfigurationData<{ shellAdapterUrl?: string }>('digital-application-configuration');

    useEffect(() => {
        if (configurationData?.shellAdapterUrl) {
            window.__SHELL_ADAPTER_URL__ = configurationData.shellAdapterUrl;
        }
    }, [configurationData]);

    return null;
};

export default function ContentfulProvider({ children }: ContentfulProviderProps) {
    const contentfulConfigs = useContentfulConfigs({
        journey: 'digital-journey',
        contentfulConfiguration: getContentfulConfiguration()
    });

    const currentLanguage = useSelector((state: RootState) => state.shell.currentLanguage);

    return (
        <ContentfulProviderFoundations config={contentfulConfigs} currentLanguage={currentLanguage}>
            <ShellAdapterInjector />
            {children}
        </ContentfulProviderFoundations>
    );
}
